import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProxmoxService } from '../../../services/proxmox.service';
import { ClientManagementService } from '../../../services/client-management.service';

@Component({
  selector: 'app-client-login',
  templateUrl: './client-login.component.html',
  styleUrls: ['./client-login.component.scss']
})
export class ClientLoginComponent implements OnInit {
  username: string = '';
  password: string = '';
  errorMessage: string = '';
  isLoading: boolean = false;

  constructor(
    private proxmoxService: ProxmoxService,
    private clientService: ClientManagementService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // If already logged in, redirect to client dashboard
    if (this.proxmoxService.isAuthenticated()) {
      this.router.navigate(['/client-dashboard']);
    }
  }

  getCurrentYear(): number {
    return new Date().getFullYear();
  }

  /**
   * Handle login form submission
   */
  onLogin(): void {
    this.isLoading = true;
    this.errorMessage = '';

    // Use traditional username/password login
    console.log('Attempting client login with username:', this.username);
    this.proxmoxService.login(this.username, this.password).subscribe({
      next: (response) => {
        this.isLoading = false;
        console.log('Client login successful, response:', response);
        
        // Store client information in session storage
        sessionStorage.setItem('clientUser', this.username);
        
        // Redirect to client dashboard after successful login
        this.router.navigate(['/client-dashboard']);
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Client login error:', error);
        
        // Provide more detailed error information
        if (typeof error === 'string' && error.includes('CORS')) {
          this.errorMessage = 'CORS error: Unable to connect to server.\n\n' +
                            'Please ensure you are connected to the internet.';
        } else if (typeof error === 'string' && error.includes('Invalid username or password')) {
          this.errorMessage = 'Invalid username or password. Please check your credentials.';
        } else if (typeof error === 'string' && error.includes('404')) {
          this.errorMessage = 'Server not found. Please try again later.';
        } else if (typeof error === 'string') {
          this.errorMessage = error;
        } else {
          this.errorMessage = 'Login failed. Please check your credentials.';
        }
      }
    });
  }

  /**
   * Navigate to admin login
   */
  onAdminLogin(): void {
    this.router.navigate(['/log-in']);
  }
}